import intlTelInput from "intl-tel-input";

export default function (number = "") {

  let iti = null;

  return {
    phone: "",
    phoneIntl: "",
    valid: false,
    error: "",

    init() {
      this.phone = number;
      this.phoneIntl = number;

      iti = intlTelInput(this.$refs.input, {
        initialCountry: "us",
        countryOrder: ["us", "ca"],
        fixDropdownWidth: false,
        countrySearch: false,
        loadUtils: () => import("intl-tel-input/utils"),
      });

      iti.promise.then(() => {
        this.validate();
      });

      this.$refs.input.addEventListener("countrychange", () => {
        this.phone = iti.getNumber();
        this.phoneIntl = iti.getNumber();
      });

      this.$refs.input.addEventListener("keyup", () => {
        this.phoneIntl = iti.getNumber();
      });

      this.$watch("phone", (val) => {
        if (val.length < 6) {
          this.error = "";
          this.valid = false;
          return;
        }

        this.validate();
      });
    },

    validate() {
      this.valid = iti.isValidNumber();

      if (!this.valid) {
        document.querySelector("#continue").disabled = true;
        const error = iti.getValidationError();
        if (error === intlTelInput.utils.validationError.TOO_SHORT) {
          this.error = "Phone number is too short.";
        } else if (error === intlTelInput.utils.validationError.TOO_LONG) {
          this.error = "Phone number is too long.";
        } else {
          this.error = "Phone number is invalid.";
        }
      } else {
        document.querySelector("#continue").disabled = false;
        this.error = "";
      }
    },
  };
}
